import React from "react";
import { useTranslation, Trans } from "react-i18next";

export const TermsOfUse = () => {
	const { t } = useTranslation();
	return (
		<>
			<div className="text-center">
				{t("pages.auth.JoinPage.components.policy.TermsOfUse.title")}
			</div>
			<div>
				<Trans
					i18nKey="pages.auth.JoinPage.components.policy.TermsOfUse.contents"
					components={[<b />, <br />]}
				/>
			</div>
		</>
	);
};

const Table01 = () => {
	const { t } = useTranslation();

	return (
		<table>
			<thead>
				<tr>
					<th style={{ width: "50%" }}>
						{t("pages.auth.JoinPage.components.policy.privacyPolicy.table01.typeQuery")}
					</th>
					<th style={{ width: "50%" }}>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.addCollecting"
						)}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.rewardTitle"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.rewardDesc"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.refundTitle"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.refundDesc"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.cacheTitle"
						)}
					</td>
					<td>
						{t("pages.auth.JoinPage.components.policy.privacyPolicy.table01.cacheDesc")}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.proposeTitle"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.proposeDesc"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.contentTitle"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.contentDesc"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.outOrderTitle"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.outOrderDesc"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{" "}
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table01.infringementTitle"
						)}
					</td>
					<td>
						<Trans
							i18nKey="pages.auth.JoinPage.components.policy.privacyPolicy.table01.infringementDesc"
							components={[<br />]}
						/>
					</td>
				</tr>
			</tbody>
		</table>
	);
};

const Table02 = () => {
	const { t } = useTranslation();

	return (
		<table>
			<thead>
				<tr>
					<th style={{ width: "33.3%" }}>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table02.providedCompany"
						)}
					</th>
					<th style={{ width: "33.3%" }}>
						{t("pages.auth.JoinPage.components.policy.privacyPolicy.table02.aim")}
					</th>
					<th style={{ width: "33.3%" }}>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table02.proviedList"
						)}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table02.providedCompany01"
						)}
					</td>
					<td>
						{t("pages.auth.JoinPage.components.policy.privacyPolicy.table02.aim01")}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table02.proviedList01"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table02.providedCompany02"
						)}
					</td>
					<td>
						{t("pages.auth.JoinPage.components.policy.privacyPolicy.table02.aim02")}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table02.proviedList02"
						)}
					</td>
				</tr>
			</tbody>
		</table>
	);
};

const Table03 = () => {
	const { t } = useTranslation();

	return (
		<table>
			<thead>
				<tr>
					<th style={{ width: "33.3%" }}>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo"
						)}
					</th>
					<th style={{ width: "33.3%" }}>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveReason"
						)}
					</th>
					<th style={{ width: "33.3%" }}>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn"
						)}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo01"
						)}
					</td>
					<td>
						{" "}
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveReason01"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn01"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo02"
						)}
					</td>
					<td></td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn02"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo03"
						)}
					</td>
					<td></td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn03"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo04"
						)}
					</td>
					<td></td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn04"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo05"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveReason05"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn05"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo06"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveReason06"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn06"
						)}
					</td>
				</tr>
				<tr>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveInfo07"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveReason07"
						)}
					</td>
					<td>
						{t(
							"pages.auth.JoinPage.components.policy.privacyPolicy.table03.archiveSapn07"
						)}
					</td>
				</tr>
			</tbody>
		</table>
	);
};

export const PrivacyPolicy = () => {
	const { t } = useTranslation();
	return (
		<>
			<div className="text-center">
				<b style={{ fontSize: "1rem" }}>
					{t("pages.auth.JoinPage.components.policy.privacyPolicy.title")}
					<br />
					<br />
				</b>
			</div>

			<Trans
				i18nKey="pages.auth.JoinPage.components.policy.privacyPolicy.contents"
				components={[<b />, <br />, <Table01 />, <Table02 />, <Table03 />]}
			/>
		</>
	);
};
